export default __webpack_public_path__ + "static/API3-7fd35044ba0d2c4b07d95425cefc8456.png";